<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
  >
    <path d="M1.74664 10H12.7466C13.146 10 13.3842 9.55493 13.1627 9.22265L10.3476 5L13.1627 0.77735C13.3842 0.445073 13.146 0 12.7466 0H1.24664C0.970501 0 0.746643 0.223858 0.746643 0.5V14.5C0.746643 14.7761 0.970501 15 1.24664 15C1.52279 15 1.74664 14.7761 1.74664 14.5V10ZM1.74664 9V1H11.8124L9.33062 4.72265C9.21865 4.8906 9.21865 5.1094 9.33062 5.27735L11.8124 9H1.74664Z" />
  </svg>
</template>
